module.exports = __webpack_public_path__ + "img/biaozhun-fenzu.b7becde0.svg";